export default {
  path: '/projects',
  component: () => import(
    /* webpackChunkName: "projects-list" */
    /* webpackPrefetch: true */
    './List'
  ),
  children: [
    {
      path: 'create',
      component: () => import(
        /* webpackChunkName: "projects-create" */
        /* webpackPrefetch: true */
        './Create'
      ),
    },
    {
      path: ':id',
      component: () => import(
        /* webpackChunkName: "projects-detail" */
        /* webpackPrefetch: true */
        './Detail'
      ),
    },
  ],
};
